// extracted by mini-css-extract-plugin
export default {"selector":"kea","disabled":"lea","hed":"mea","selected":"nea","subHed":"oea","standard":"pea","flavor":"qea","flavorImage":"rea","long":"sea"};
    if(module.hot) {
      // 1721922369144
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  